export const Limit = Object.freeze({
	ResourcesDialog: 20,
});
